export function buildCollectiveScheduleWhatsAppMessage({
  title,
  schedule,
  scheduleDate,
  rehearsalLabel = 'Ensaio',
  includeRooms = false,
  includeSongs = false,
  closing = 'Vamos fazer acontecer!',
}) {
  let message = `*${title}*\n`;
  message += `"""""""""""""""""""\n\n`;
  message += `*${schedule.title}*\n\n`;
  message += `*Data:* ${scheduleDate}\n`;

  if (schedule.start_time) {
    message += `*Horario:* ${schedule.start_time}`;
    if (schedule.end_time) message += ` - ${schedule.end_time}`;
    message += `\n`;
  }

  if (schedule.arrival_time) {
    message += `*Horario de Chegada:* ${schedule.arrival_time}\n`;
  }

  if (schedule.location) {
    message += `*Local:* ${schedule.location}\n`;
  }

  if (schedule.rehearsal_time) {
    message += `*${rehearsalLabel}:* ${schedule.rehearsal_time}\n`;
  }

  if (schedule.members?.length > 0) {
    message += `\n*EQUIPE COMPLETA:*\n`;
    schedule.members.forEach((member) => {
      message += `- ${member.name}`;
      if (includeRooms && member.room) message += ` (${member.room})`;
      if (member.role) message += ` -> *${member.role}*`;
      message += `\n`;
    });
  }

  if (includeSongs && schedule.songs?.length > 0) {
    message += `\n*HINOS DA ESCALA:*\n`;
    schedule.songs.forEach((song, index) => {
      message += `${index + 1}. *${song.title}*`;
      if (song.key) message += ` (Tom: ${song.key})`;
      message += `\n`;
    });
  }

  if (schedule.observations) {
    message += `\n"""""""""""""""""""\n`;
    message += `*OBSERVACOES IMPORTANTES:*\n${schedule.observations}\n`;
  }

  message += `\n*Confirmar Presenca ou Solicitar Alteracao em Escala*`;
  message += `\n*${closing}*`;

  return message;
}

export function buildWhatsAppShareUrl(message) {
  return `https://wa.me/?text=${encodeURIComponent(message)}`;
}
